import { useState } from "react";
import { Svg } from "react-native-svg";
import {
  Accordion,
  Box,
  HStack,
  Pressable,
  Text,
  useMediaQuery,
} from "native-base";
import {
  accordionExpandCloseSVG,
  accordionExpandOpenSVG,
  downloadIconSVG,
} from "../../utils/svg";
import { COLORS } from "../../utils/colors";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import CustomModal from "../modal";
import FileViewerComponent from "../fileViewer";
import MobileModelSheet from "../actionSheet";
import "./style.css";
import { useDispatch } from "react-redux";
import { setIsDownloading } from "../../store/reducers/eventSlice";

const AccordionDetail = ({
  index = "",
  openIndex = "",
  isOpen = false,
  setIsOpen = () => {},
  title = "",
  content = "",
  type = "",
  path = "",
  setOpenIndex = () => {},
  eventBreakDown = false,
}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const customStyle = {
    accordion: {
      boxShadow: "0px 18.953px 47.382px 0px rgba(119, 115, 170, 0.10)",
      border: "none",
      borderRadius: "8px",
    },
    accordionItem: {
      backgroundColor: COLORS.WHITE_COLOR,
      borderBottomWidth:
        (type === "policy" || type === "travel") &&
        index === openIndex &&
        isOpen &&
        2,
      borderBottomColor:
        index === openIndex && isOpen && COLORS.ACCORDION_BORDER_COLOR,
    },
  };
  const handleToggle = () => {
    setOpenIndex(index);
    setIsOpen(!isOpen);
  };

  const handleSVG = (cond) => {
    return (
      <Svg width="24" height="24" viewBox="0 0 24 24">
        {cond === "-" ? accordionExpandOpenSVG : accordionExpandCloseSVG}
      </Svg>
    );
  };

  const getModalHeader = () => {
    return (
      <HStack
        justifyContent={"space-between"}
        width={MobileWindow ? "99%" : "95%"}
      >
        <Text width={MobileWindow && "100%"}>{`${title} - ${content}`}</Text>

        <Pressable
          onPress={() => {
            dispatch(setIsDownloading(true));
            const parts = path.split(".com");
            const filename = decodeURIComponent(parts[1].trim("/"));
            const sanitizedFilename = decodeURIComponent(filename).replace(
              /^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/g,
              ""
            );

            fetch(path)
              .then((response) => response.blob())
              .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = sanitizedFilename;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
              })
              .catch((error) => {
                console.error("Error downloading file:", error);
              });
              dispatch(setIsDownloading(false));
          }}
        >
          <Box mt={MobileWindow && 1}>
            {/* <i
              className="fa fa-download pointer"
              style={{ color: "black" }}
            ></i> */}
            <Svg width="50" height="40" viewBox="0 0 1 36">
              {downloadIconSVG}
            </Svg>
          </Box>
        </Pressable>
      </HStack>
    );
  };

  return (
    <>
      <Accordion key={index} style={customStyle.accordion}>
        <Accordion.Item isOpen={index === openIndex && isOpen}>
          <Accordion.Summary
            onClick={() => handleToggle()}
            p={type !== "agencies" ? 6 : 4}
            pb={index === openIndex && isOpen ? 4 : 6}
            pl={type === "agencies" ? 4 : MobileWindow ? 4 : 9}
            mb={index === openIndex && isOpen && 0}
            style={customStyle.accordionItem}
            _hover={{ backgroundColor: "transparent" }}
          >
            <Text
              fontWeight="600"
              fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
              color={COLORS.ACCORDION_TITLE_COLOR}
            >
              {title}
            </Text>
            {index === openIndex && isOpen ? handleSVG("-") : handleSVG("+")}
          </Accordion.Summary>
          {index === openIndex && isOpen && (
            <div className={!eventBreakDown && "accordion-contents"}>
              <Accordion.Details pt={0} style={customStyle.accordionItem}>
                <Box
                  px={
                    type === "agencies"
                      ? MobileWindow
                        ? 0
                        : 1
                      : MobileWindow
                      ? 0
                      : 6
                  }
                  pr={MobileWindow && 0.5}
                  pt={5}
                  pb={(type === "policy" || type === "travel") && 3}
                >
                  {type === "policy" ? (
                    <Pressable onPress={openModal}>
                      <Text
                        style={{
                          color: COLORS.THEME_COLOR,
                          fontWeight: COMMONFONTWEIGHT.LARGE_FONT_WEIGHT,
                        }}
                      >
                        {title === "Policy"
                          ? "MICE Events Policy Jan 26 to Dec 28.pdf"
                          : "MICE Events Policy Circular.pdf"}
                      </Text>
                    </Pressable>
                  ) : (
                    //  <a
                    //   style={{
                    //     textDecoration: "none",
                    //     color: COLORS.THEME_COLOR,
                    //   }}
                    //   href={index === 0 ? policyPdf : circularPdf}
                    //   download={
                    //     index === 0
                    //       ? "MICE Events Policy_Jan24.pdf"
                    //       : "MICE Events Policy Circular.pdf"
                    //   }
                    // >
                    //   {index === 0
                    //     ? "MICE Events Policy_Jan24.pdf"
                    //     : "MICE Events Policy Circular.pdf"}
                    // </a>
                    <Text>{content}</Text>
                  )}
                </Box>
              </Accordion.Details>
            </div>
          )}
        </Accordion.Item>
      </Accordion>
      {type === "policy" && showModal && path && !MobileWindow ? (
        <CustomModal
          size=""
          top={"50px"}
          isOpen={showModal}
          onClose={closeModal}
          header={getModalHeader()}
          body={showModal && <FileViewerComponent path={path} height="75vh" />}
          footer={""}
          width={MobileWindow ? "100%" : "90%"}
          height={"90vh"}
        />
      ) : (
        <MobileModelSheet
          isOpen={showModal}
          onClose={closeModal}
          header={getModalHeader()}
          body={showModal && <FileViewerComponent path={path} height="65vh" />}
          maxH={"80vh"}
          position="hidden"
        />
      )}
    </>
  );
};

export default AccordionDetail;
